export default{
  bind(el,binding,vnode){


  },
  inserted(el ,binding,vnode){

  },
  update(el,binding,vnode){

  },
  componentUpdated (el, binding, vnode) {},
  unbind (el, binding, vnode) {}
}



// WEBPACK FOOTER //
// ./src/directives/modules/test.js